import { ESolutionNames } from '@/types/integrations.types';
import { BrandliveEvent } from '@/types/projects.types';

export function getIntegrationSchema(name: string | null, uuid?: string) {
  if (!name || !uuid) return;
  switch (name) {
    case ESolutionNames.Marketo: {
      return `{"target": "${uuid}","email_address":{{lead.Email Address:default=edit me}},"first_name": {{lead.First Name:default=edit me}},"last_name": {{lead.Last Name:default=edit me}}}`;
    }
    case ESolutionNames.Salesforce:
    case ESolutionNames.Hubspot: {
      return JSON.stringify(
        {
          target: uuid,
          email_address: "<user's email address>",
          first_name: "<user's first name>",
          last_name: "<user's last name>",
          company: "<user's company>",
          title: "<user's job title>",
        },
        null,
        2
      );
    }
    default: {
      return JSON.stringify(
        {
          target: uuid,
          data: {
            email_address: "<user's email address>",
            first_name: "<user's first name>",
            last_name: "<user's last name>",
            company: "<user's company>",
            title: "<user's job title>",
          },
        },
        null,
        2
      );
    }
  }
}

export function getIntegrationResponse(name: string | null) {
  if (!name) return;
  switch (name) {
    case ESolutionNames.Custom:
    case ESolutionNames.Salesforce:
    case ESolutionNames.Hubspot:
    case ESolutionNames.Marketo: {
      return JSON.stringify(
        {
          link: '<registered link for event>',
        },
        null,
        2
      );
    }
    default:
      return;
  }
}

/**
 * This should probably be moved a registraiton utils file
 * Returns true if the event is using an external source for registrations.
 * @param event
 * @returns boolean
 */
export const isExternalRegistration = (event: BrandliveEvent | null): boolean => {
  return !!event?.registration_settings?.externalRegistration?.isOn;
};
